<div class="thank-you-page" >
  <div class="container">
    <div class="content" [innerHTML]="this.thankYouPageContent?.fields?.content"></div>
  </div>
</div>